import s from "../clinic.module.css";
import { Button } from "../../ui";
import GroupDraftFields from "./GroupDraftFields";

function groupSubtitle(group) {
  const parts = [];
  if (group.direction?.name || group.sport_direction) {
    parts.push(group.direction?.name || group.sport_direction);
  }
  if (group.branch?.name) parts.push(group.branch.name);
  return parts.join(" · ");
}

export default function GroupsStepForm({
  groups,
  draft,
  onDraftChange,
  directions,
  branches,
  onAdd,
  onRemove,
  onContinue,
  saving,
  adding,
  submitLabel = "Продолжить",
}) {
  const canContinue = groups.length > 0;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (canContinue) onContinue(e);
      }}
      className={[s.onboardingForm, s.onboardingGroupsForm].join(" ")}
    >
      <GroupDraftFields
        form={draft}
        onChange={onDraftChange}
        directions={directions}
        branches={branches}
        onAdd={onAdd}
        adding={adding}
        addDisabled={!directions.length || !branches.length}
      />

      <section className={s.onboardingVenueListBlock} aria-live="polite">
        <h4 className={s.onboardingVenueListTitle}>
          Группы ({groups.length})
        </h4>
        {groups.length === 0 ? (
          <p className={s.onboardingVenueListEmpty}>Пока нет групп</p>
        ) : (
          <ul className={s.onboardingGroupsList}>
            {groups.map((group) => (
              <li key={group.id} className={s.onboardingGroupListCard}>
                <div className={s.onboardingGroupListCardBody}>
                  <strong>{group.name}</strong>
                  {groupSubtitle(group) ? (
                    <span>{groupSubtitle(group)}</span>
                  ) : null}
                </div>
                <button
                  type="button"
                  className={s.onboardingVenueCardRemove}
                  onClick={() => onRemove(group.id)}
                  aria-label={`Удалить ${group.name}`}
                >
                  ×
                </button>
              </li>
            ))}
          </ul>
        )}
      </section>

      <div className={s.onboardingSheetFoot}>
        <Button
          type="submit"
          disabled={!canContinue || saving}
          className={s.onboardingSubmitBtn}
          block
        >
          {saving ? "Сохранение…" : submitLabel}
        </Button>
      </div>
    </form>
  );
}
